import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';

const ProfileImageUploader = ({ onUploaded }) => {
  const [uploading, setUploading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [currentUrl, setCurrentUrl] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [error, setError] = useState('');
  const fileInputRef = useRef(null);

  const fetchCurrent = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/user`);
      setCurrentUrl(res.data.profile_image_url || null);
    } catch (err) {
      // ignore
    }
  };

  useEffect(() => {
    fetchCurrent();
  }, []);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    setError('');
    const formData = new FormData();
    formData.append('image', file);

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/user/profile-image`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (res.data && res.data.url) {
        setCurrentUrl(res.data.url);
        if (onUploaded) onUploaded(res.data);
      }
    } catch (err) {
      setError('アップロードに失敗しました');
    }

    setUploading(false);
    // アップロード後にfile inputをリセット
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleDelete = () => {
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setDeleting(true);
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/user/profile-image`);
      setCurrentUrl(null);
      if (onUploaded) onUploaded(null);
      setShowDeleteModal(false);
      // 削除時にfile inputもリセット
      if (fileInputRef.current) fileInputRef.current.value = "";
    } catch (err) {
      setError('削除に失敗しました');
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div style={{ marginBottom: 12 }}>
      {error && <p style={{ color: '#dc2626', margin: '0 0 8px' }}>{error}</p>}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ width: 96, height: 96, borderRadius: 8, overflow: 'hidden', background: '#f4f4f4' }}>
          <img src={currentUrl || '/default-profile.png'} alt="プロフィール画像" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <input type="file" accept="image/*" onChange={handleUpload} disabled={uploading || deleting} ref={fileInputRef} />
          {currentUrl && <button type="button" onClick={handleDelete} disabled={deleting}>削除</button>}
        </div>
      </div>

      {showDeleteModal && (
        <div
          role="dialog"
          aria-modal="true"
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.45)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 16,
            zIndex: 2000,
          }}
          onClick={() => {
            if (!deleting) setShowDeleteModal(false);
          }}
        >
          <div
            style={{
              width: 'min(420px, 100%)',
              background: '#fff',
              border: '1px solid #ddd',
              borderRadius: 10,
              padding: 16,
              boxShadow: '0 16px 32px rgba(0,0,0,.2)',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>プロフィール画像を削除しますか？</h3>
            <p style={{ margin: '10px 0 0', color: '#444', fontSize: 14 }}>この操作は取り消せません。</p>
            <div style={{ marginTop: 14, display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button
                type="button"
                onClick={confirmDelete}
                disabled={deleting}
                style={{ border: '1px solid #dc2626', background: '#fff', color: '#dc2626', borderRadius: 8, padding: '8px 12px', fontWeight: 700, cursor: 'pointer' }}
              >
                {deleting ? '削除中...' : '削除する'}
              </button>
              <button
                type="button"
                onClick={() => setShowDeleteModal(false)}
                disabled={deleting}
                style={{ border: '1px solid #bbb', background: '#fff', color: '#333', borderRadius: 8, padding: '8px 12px', fontWeight: 700, cursor: 'pointer' }}
              >
                戻る
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileImageUploader;
